import { GPTGameButton } from './GPTGameButton';
import { GptGameButtonProps } from '../types';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { BonusEventIcon } from './GPTEventIcons/BonusEventIcon';

export const DailyBonusButton = ({ isCollapsed, isEventActive }: GptGameButtonProps) => {
  const { startRegistration } = useAuthFlow();

  return (
    <GPTGameLauncher
      gameName="dailyBonus"
      renderButton={({ Icon, ...props }) => (
        <GPTGameButton
          {...props}
          Icon={isEventActive ? BonusEventIcon : Icon}
          isCompact={isCollapsed}
        />
      )}
      openRegistration={startRegistration}
    />
  );
};
